import React from "react";
import { Container } from "./styles";

export default function ExportarSec() {
  return <Container>{/* Nome */}</Container>;
}
